
import { cn } from "@/lib/utils";

const BrandLogo = ({
    logoSize = "h-8",
    textSize = "text-xl",
    className,
    suffix,
    iconOnly
}) => {
    return (
        <div className={cn("flex items-center gap-2.5", className)}>
            <svg width={iconOnly ? "21" : "114"} height="32" viewBox={iconOnly ? "0 0 21 32" : "0 0 114 32"} fill="none" xmlns="http://www.w3.org/2000/svg" className={logoSize}>
                <path d="M20.0488 14.2646H6.16931L3.08497 17.7345H20.0488V14.2646Z" fill="url(#paint0_linear_344_6847)" />
                <path d="M20.0488 21.2051H3.08497L0.000635147 24.675H20.0488V21.2051Z" fill="url(#paint1_linear_344_6847)" />
                <path d="M20.0488 7.3252H9.63919L6.16931 10.7951H20.0488V7.3252Z" fill="url(#paint2_linear_344_6847)" />
                {!iconOnly && <path d="M23.0441 25L28.9907 16.2158L23.0935 7.48096H27.4362L31.2608 13.3782L34.9867 7.48096H39.3541L33.4569 16.1665L39.4281 25H35.0607L31.2115 19.004L27.4116 25H23.0441ZM42.5547 25V7.48096H46.3052V25H42.5547ZM50.8487 25V7.48096H57.6589C59.8303 7.48096 61.4917 7.86753 62.6432 8.64067C63.7947 9.39736 64.3704 10.5982 64.3704 12.2432C64.3704 12.967 64.2224 13.6003 63.9263 14.1431C63.6302 14.6695 63.1942 15.089 62.6185 15.4015C62.0592 15.7141 61.3765 15.9033 60.5705 15.9691V15.9197C62.0345 16.0184 63.1531 16.4461 63.9263 17.2028C64.7159 17.943 65.1106 18.93 65.1106 20.1638C65.1106 21.7923 64.5349 23.0096 63.3834 23.8156C62.2484 24.6052 60.6199 25 58.4978 25H50.8487ZM54.5992 21.9403H58.3251C59.2298 21.9403 59.9536 21.7594 60.4965 21.3975C61.0558 21.0191 61.3354 20.4599 61.3354 19.7196C61.3354 18.9794 61.0558 18.4201 60.4965 18.0417C59.9536 17.6469 59.2298 17.4495 58.3251 17.4495H54.5992V21.9403ZM54.5992 14.7353H57.5602C58.4814 14.7353 59.2134 14.5544 59.7562 14.1925C60.3155 13.8306 60.5952 13.3124 60.5952 12.638C60.5952 11.9142 60.3238 11.3878 59.7809 11.0588C59.2545 10.7133 58.5143 10.5406 57.5602 10.5406H54.5992V14.7353ZM69.1908 25V7.48096H81.3801V10.6393H72.9414V14.6613H81.084V17.7703H72.9414V21.8416H81.5775V25H69.1908ZM85.774 25V7.48096H89.5245V23.9883L87.4519 21.8416H97.5932V25H85.774ZM100.935 25V7.48096H104.686V23.9883L102.613 21.8416H112.755V25H100.935Z" fill="currentColor" />}
                <defs>
                    <linearGradient id="paint0_linear_344_6847" x1="20.5022" y1="15.9996" x2="0.51003" y2="15.9996" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#3B32D1" />
                        <stop offset="1" stopColor="#776EFF" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_344_6847" x1="20.5846" y1="22.94" x2="-3.04248" y2="22.94" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#3B32D1" />
                        <stop offset="1" stopColor="#776EFF" />
                    </linearGradient>
                    <linearGradient id="paint2_linear_344_6847" x1="20.4197" y1="9.06014" x2="4.06254" y2="9.06014" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#3B32D1" />
                        <stop offset="1" stopColor="#776EFF" />
                    </linearGradient>
                </defs>
            </svg>
            {suffix && (
                <span className={cn("font-bold text-gray-900 dark:text-white", textSize)}>
                    {suffix}
                </span>
            )}
        </div>
    );
};

export default BrandLogo;
